import logo from './logo.svg';
import './App.css';
// import '../src/Fonts/DrukWideBold.tff'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>

      <div className="bg-slate-500 text-sm">SLATE</div>
    </div>
  );
}

export default App;
